/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Ledgertype2Inputs */

const zh_adminsubs_ledgertype2 = /** @type {(inputs: Adminsubs_Ledgertype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

const en_adminsubs_ledgertype2 = /** @type {(inputs: Adminsubs_Ledgertype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const es_adminsubs_ledgertype2 = /** @type {(inputs: Adminsubs_Ledgertype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Adminsubs_Ledgertype2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_ledgertype2 = /** @type {((inputs?: Adminsubs_Ledgertype2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Ledgertype2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_ledgertype2(inputs)
	if (locale === "en") return en_adminsubs_ledgertype2(inputs)
	return es_adminsubs_ledgertype2(inputs)
});
export { adminsubs_ledgertype2 as "adminSubs_ledgerType" }